import { createContext } from 'react';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';

export interface ActionMenuContextProps {
  colorMode: ColorMode;
  isOpen: boolean;
}

/**
 * A single selection tile group context was created because the value type is
 * different between single and multi, and, the radio group component (context)
 * does not support custom props being passed down.
 */
export const ActionMenuContext = createContext<ActionMenuContextProps>({
  colorMode: 'light',
  isOpen: false,
});
